'use client';

import { Box, Rating, Stack, Typography } from '@mui/material';
const Reviews = ({
  reviews
}: {
  reviews: Array<{
    name: string;
    text: string;
    rating: number;
  }>;
}) => {
  return <Box data-sentry-element="Box" data-sentry-component="Reviews" data-sentry-source-file="Reviews.tsx">
      <Typography variant="h3" fontWeight="bold" textAlign="center" sx={{
      mb: 6
    }} component="h2" data-sentry-element="Typography" data-sentry-source-file="Reviews.tsx">
        What Our Students Say
      </Typography>

      <Stack spacing={6} data-sentry-element="Stack" data-sentry-source-file="Reviews.tsx">
        {reviews.map((review, index) => <Box key={index} textAlign="center">
            <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
              <Rating value={review.rating} readOnly size="large" />
              <Typography fontWeight="bold" fontSize="1.2rem">
                {review.rating}
                /5
              </Typography>
            </Stack>
            <Typography variant="h5" component="h3" fontWeight="normal" textAlign="center" sx={{
          mt: 2
        }}>
              {review.text}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{
          mt: 1
        }}>
              —
              {' '}
              {review.name}
            </Typography>
          </Box>)}
      </Stack>
    </Box>;
};
export default Reviews;